module.exports = __webpack_public_path__ + "img/blue_heart.5784fcbe.png";